<template>
  <div
    v-show="loading"
    class="t-loader">
    <div
      :style="spinnerStyle"
      class="v-clip"/>
  </div>
</template>

<script>
export default {
	name: 't-loader',
	props: {
		loading: {
			type: Boolean,
			default: true
		},
		color: {
			type: String,
			default: '#5dc596'
		},
		size: {
			type: String,
			default: '35px'
		},
		radius: {
			type: String,
			default: '100%'
		},
		customStyle: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	computed: {
		spinnerStyle () {
			return {
				borderWidth: '2px',
				borderStyle: 'solid',
				borderColor: this.color + ' ' + this.color + ' transparent',
				borderRadius: this.radius,
				background: 'transparent',
				position: 'absolute',
				top: 0,
				bottom: 0,
				left: 0,
				right: 0,
				height: this.size,
				width: this.size,
				margin: 'auto',
				...this.customStyle
			}
		}
	}
}
</script>

  <style>
  .t-loader
  {
      text-align: center;
  }
  .t-loader .v-clip
  {
      -webkit-animation: v-clipDelay 0.75s 0s infinite linear;
              animation: v-clipDelay 0.75s 0s infinite linear;
      -webkit-animation-fill-mode: both;
                animation-fill-mode: both;
      display: inline-block;
  }
  @-webkit-keyframes v-clipDelay
  {
      0%
      {
          -webkit-transform: rotate(0deg) scale(1);
                  transform: rotate(0deg) scale(1);
      }
      50%
      {
          -webkit-transform: rotate(180deg) scale(0.8);
                  transform: rotate(180deg) scale(0.8);
      }
      100%
      {
          -webkit-transform: rotate(360deg) scale(1);
                  transform: rotate(360deg) scale(1);
      }
  }
  @keyframes v-clipDelay
  {
      0%
      {
          -webkit-transform: rotate(0deg) scale(1);
                  transform: rotate(0deg) scale(1);
      }
      50%
      {
          -webkit-transform: rotate(180deg) scale(0.8);
                  transform: rotate(180deg) scale(0.8);
      }
      100%
      {
          -webkit-transform: rotate(360deg) scale(1);
                  transform: rotate(360deg) scale(1);
      }
  }
  </style>



// WEBPACK FOOTER //
// src/components/common/loader/index.vue